var currentRequest = null;
const AutoComplete = {
    base_url: $('#base-url').attr('data-url'),
    handleResults(results, $input) {
        var $results = $input.next('.autocomplete-results');
        var $no_results = $input.next().next('.autocomplete-no-results');      

        $no_results.removeClass('is-active');

        $results.empty();

        var is_small = $results.width() < 480 ? 'is-small' : '';
        $.each(results, function (i, loc) {
            var $icon =
                loc.post_type == 'locations'
                    ? `<svg class="h-[26px] w-[18px] text-brand-coral flex-none" xmlns="http://www.w3.org/2000/svg" viewbox="0 0 18 26"><path fill="currentColor" fill-rule="nonzero" d="M17.575 6.471c-.093-.347-.282-.716-.422-1.04C15.481 1.433 11.828 0 8.878 0 4.93 0 .581 2.635 0 8.066v1.11c0 .045.016.461.039.67.325 2.588 2.378 5.338 3.91 7.926C5.6 20.545 7.31 23.273 9.006 26c1.045-1.78 2.087-3.582 3.109-5.315.278-.51.601-1.018.88-1.503.186-.323.54-.647.703-.947C15.346 15.23 18 12.203 18 9.22V7.997c0-.324-.403-1.456-.425-1.526Zm-8.624 5.57c-1.161 0-2.432-.577-3.059-2.172-.093-.254-.086-.763-.086-.81v-.716c0-2.033 1.735-2.958 3.245-2.958 1.858 0 3.295 1.48 3.295 3.328 0 1.85-1.537 3.328-3.395 3.328Z"/></svg>`
                    : `<svg class="h-[26px] w-[18px] text-brand-coral flex-none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26"><g fill="none" fill-rule="nonzero"><path fill="currentColor" d="M9.082 16.461h1v1h-1zM12.542 6.081h1v1h-1zM12.542 13.001h1v1h-1zM12.542 9.541h1v1h-1zM12.542 2.621h1v1h-1zM16.002 13.001h1v1h-1zM16.002 9.541h1v1h-1zM16.002 6.081h1v1h-1zM16.002 2.621h1v1h-1z"/><path fill="currentColor" d="M25.569 25.11h-4.377V2.188c0-.408-.193-.792-.519-1.038L19.289.112a.24.24 0 0 0-.074-.038C19.207.069 19.202.06 19.19.06a.344.344 0 0 0-.148-.03c-.004 0-.008-.005-.012-.005H6.92c-.005 0-.009.004-.013.004-.05 0-.101.01-.147.03-.013 0-.017.01-.026.014a.397.397 0 0 0-.074.038L5.276 1.15c-.326.246-.518.63-.519 1.038V25.11H.432a.432.432 0 1 0 0 .865H25.57a.432.432 0 0 0 0-.865Zm-19.082 0h-.865V2.188c.001-.136.065-.263.173-.346l.692-.519V25.11Zm5.19-22.49a.868.868 0 0 1 .865-.864h.865a.868.868 0 0 1 .865.865v.865a.868.868 0 0 1-.865.865h-.865a.868.868 0 0 1-.865-.865V2.62Zm0 3.46a.868.868 0 0 1 .865-.864h.865a.868.868 0 0 1 .865.865v.865a.868.868 0 0 1-.865.865h-.865a.868.868 0 0 1-.865-.865V6.08Zm0 3.46a.868.868 0 0 1 .865-.864h.865a.868.868 0 0 1 .865.865v.865a.868.868 0 0 1-.865.865h-.865a.868.868 0 0 1-.865-.865V9.54Zm0 3.46a.868.868 0 0 1 .865-.864h.865a.868.868 0 0 1 .865.865v.865a.868.868 0 0 1-.865.865h-.865a.868.868 0 0 1-.865-.865V13ZM10.38 25.11H9.082v-3.46h1.298v3.46Zm.432-7.785a.868.868 0 0 1-.865.865h-.865a.868.868 0 0 1-.865-.865v-.865a.868.868 0 0 1 .865-.865h.865a.868.868 0 0 1 .865.865v.865Zm0-3.46a.868.868 0 0 1-.865.866h-.865a.868.868 0 0 1-.865-.865V13a.868.868 0 0 1 .865-.865h.865a.868.868 0 0 1 .865.865v.865Zm0-3.46a.868.868 0 0 1-.865.866h-.865a.868.868 0 0 1-.865-.865V9.54a.868.868 0 0 1 .865-.865h.865a.868.868 0 0 1 .865.865v.865Zm0-3.46a.868.868 0 0 1-.865.866h-.865a.868.868 0 0 1-.865-.865V6.08a.868.868 0 0 1 .865-.865h.865a.868.868 0 0 1 .865.865v.865Zm0-3.46a.868.868 0 0 1-.865.866h-.865a.868.868 0 0 1-.865-.865V2.62a.868.868 0 0 1 .865-.865h.865a.868.868 0 0 1 .865.865v.865Zm1.73 21.625h-1.297v-3.46h1.297v3.46Zm-.865-7.785v-.865a.868.868 0 0 1 .865-.865h.865a.868.868 0 0 1 .865.865v.865a.868.868 0 0 1-.865.865h-.865a.868.868 0 0 1-.865-.865Zm3.028 7.785h-1.298v-3.46h1.298v3.46Zm2.162 0H15.57v-3.46h1.297v3.46Zm.865-7.785a.868.868 0 0 1-.865.865h-.865a.868.868 0 0 1-.865-.865v-.865a.868.868 0 0 1 .865-.865h.865a.868.868 0 0 1 .865.865v.865Zm0-3.46a.868.868 0 0 1-.865.866h-.865a.868.868 0 0 1-.865-.865V13a.868.868 0 0 1 .865-.865h.865a.868.868 0 0 1 .865.865v.865Zm0-3.46a.868.868 0 0 1-.865.866h-.865a.868.868 0 0 1-.865-.865V9.54a.868.868 0 0 1 .865-.865h.865a.868.868 0 0 1 .865.865v.865Zm0-3.46a.868.868 0 0 1-.865.866h-.865a.868.868 0 0 1-.865-.865V6.08a.868.868 0 0 1 .865-.865h.865a.868.868 0 0 1 .865.865v.865Zm0-3.46a.868.868 0 0 1-.865.866h-.865a.868.868 0 0 1-.865-.865V2.62a.868.868 0 0 1 .865-.865h.865a.868.868 0 0 1 .865.865v.865Zm2.595 21.625h-.865V1.323l.692.52c.108.082.172.21.173.345V25.11Z"/><path fill="currentColor" d="M9.082 13.001h1v1h-1zM9.082 6.081h1v1h-1zM9.082 9.541h1v1h-1zM12.542 16.461h1v1h-1zM9.082 2.621h1v1h-1zM16.002 16.461h1v1h-1z"/></g></svg>`;

            var $loc = `
                <li class="group autocomplete-results__item ${is_small}">
                    <a href="${loc.link}" class="autocomplete-results__link pl-0">
                        ${$icon}
                        <span class="${
                            is_small
                                ? 'flex flex-col items-start'
                                : 'flex items-center gap-8'
                        }">
                            <span class="text-brand-md-blue group-hover:text-brand-primary ">
                                ${loc.title}
                            </span>
                            <span>
                            ${
                                loc.post_type == 'locations'
                                    ? `${loc.num_properties} Properties`
                                    : `${loc.location}`
                            }
                            </span>
                        </span>
                    </a>
                </li>
            `;
            $results.append($loc);
        });
        $results.addClass('is-active');

        // focus the first result
        $(document).on('keydown', AutoComplete.handleUpDown);  
    },
    handleNoResults($input) {
        var $results = $input.next('.autocomplete-results');
        var $no_results = $input.next().next('.autocomplete-no-results');

        $results.empty();
        $results.removeClass('is-active');
        $no_results.addClass('is-active');
    },
    clearResults($input) {
        var $results = $input.next('.autocomplete-results');
        var $no_results = $input.next().next('.autocomplete-no-results');

        $results.empty().removeClass('is-active');
        $no_results.removeClass('is-active');
    },
    doSearch($input) {
        $(document).off('keydown', AutoComplete.handleUpDown);

        if ($input.val().length > 2) {
            AutoComplete.clearResults($input);
            AutoComplete.showLoader($input);

            currentRequest = $.ajax({
                url: AutoComplete.base_url + '/wp-admin/admin-ajax.php',
                type: 'post',
                data: {
                    action: 'autocomplete_location_property_search',
                    s: $input.val(),
                },
                beforeSend: function () {
                    if (currentRequest != null) {
                        currentRequest.abort();
                    }
                },
                success: function (data) {
                    AutoComplete.hideLoader($input);
                    if (data) {
                        var results = JSON.parse(data);
                        if (results && results.length > 0) {
                            AutoComplete.handleResults(results, $input);
                        } else {
                            AutoComplete.clearResults($input);
                            if ($input.val().length > 2) {
                                AutoComplete.handleNoResults($input);
                            }
                        }
                    }
                },
            });
        }
    },
    handleUpDown(e) {
        var $focused_li = $('.autocomplete-results a:focus').parent();

        // if in input, make the down press select the first option
        switch (e.keyCode) {
            case 38: // up
                if ($focused_li.length > 0 && $focused_li.index() > 0) {
                    // if in a result, select the previous result
                    $focused_li.prev().find('a').focus();
                    return false;
                }
                break;
            case 40: // down
                if ($('.autocomplete-input:focus').length > 0) {
                    // if in the autocomplete, select the first result
                    $('.autocomplete-input:focus')
                        .next('.autocomplete-results')
                        .find('li')
                        .eq(0)
                        .find('a')
                        .trigger('focus');
                    return false;
                }

                if ($focused_li.length > 0 && $focused_li.next().length > 0) {
                    // if in a result, select the next result
                    $focused_li.next().find('a').focus();
                    $focused_li.next()[0].scrollIntoView({
                        behavior: 'smooth',
                        block: 'nearest',
                        inline: 'start',
                    });

                    return false;
                }
                break;
        }
    },
    showLoader($input) {
        $input.parent().find('.autocomplete-loading').addClass('is-loading');
    },
    hideLoader($input) {
        $input.parent().find('.autocomplete-loading').removeClass('is-loading');
    },
    init() {
        $('.autocomplete-input').each(function () {
            var $ac = $(this);
            $(this).on('keyup', function () {
                AutoComplete.doSearch($ac);
            });
        });

        $('.autocomplete-input').on('click', function () {
            AutoComplete.doSearch($(this));
        });

        // remove results on click outside
        $(document).on('click', function (event) {
            var $target = $(event.target);
            if (
                !$target.closest('.autocomplete').length &&
                $('.autocomplete').is(':visible')
            ) {
                AutoComplete.clearResults($('.autocomplete-input'));
                // console.log("click");
            }
        });

       
    },
};

export default AutoComplete;
